import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DesarrolloAltas } from '../altas/desarrollo-altas';
import { Constantes } from 'src/app/utilerias/constantes/constantes';
import { TiposFiltrosIncidencia } from 'src/app/shared/model/incidencias/tiposFiltrosIncidencia.model';
import { IncidenciasService } from 'src/app/incidencias/incidencias.service';
import { ProyectoCliente } from '../models/proyectocliente';
import { EtapaCliente } from '../models/etapacliente';
import { FiltrosIncidenciaEnum } from 'src/app/shared/enum/filtro.incidencia.enum';
import { EstatusCliente } from '../models/estatuscliente';
import { EmpleadoCliente } from '../models/empleadocliente';
import { TBabierto, Tile } from '../models/tablaincidencias';
import { ConstanteCliente } from '../models/constantecliente';
import { IncidenciaCliente } from '../models/incidenciacliente';
import { NgxPaginationModule } from 'ngx-pagination';
import { DetalleErroresComponent } from '../detalle-errores/detalle-errores.component';
import { MatFormField, MatInput, MatSuffix } from '@angular/material/input';
import { MatSelect, MatSelectTrigger } from '@angular/material/select';
import { NgFor, NgIf, NgClass } from '@angular/common';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { SoloNumeroEnteroDirective } from '../../utilerias/directives/solo-numero-entero.directive';
//import { MatDivider } from '@angular/material/list';
import { MatTooltip } from '@angular/material/tooltip';


@Component({
    selector: 'app-desarrollo-clientes',
    standalone : true,
    templateUrl: './desarrollo-clientes.component.html',
    styleUrls: ['./desarrollo-clientes.component.css'],
    imports: [MatFormField, MatSelect, FormsModule, NgFor, MatOption, NgIf, MatButton, NgClass, ReactiveFormsModule, MatSelectTrigger, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, SoloNumeroEnteroDirective, MatTooltip, NgxPaginationModule]
})
export class DesarrolloClientesComponent implements OnInit, OnDestroy {
// Paginacion
p:number=1;
p2:number=1;
p3:number=1;
p4:number=1;

proyectoF
public labels: any = {
previousLabel: '<',
nextLabel: '>',
}

  //Empieza las columnas para la tabla
Abierto:ConstanteCliente[];
SelectAbierto:number;
Observacion:ConstanteCliente[]
SelectObservacion:number;
Proceso:ConstanteCliente[];
SelectProceso:number;
Resultado:ConstanteCliente[];
Select:number;

current: Boolean = false;
proyectocliente:ProyectoCliente[];
selectProyecto:Number;
etapacliente:EtapaCliente[];
selectEtapa: number;
estatuscliente:EstatusCliente[];
selectEstatu:number;
empleadocliente:EmpleadoCliente[];
selectEmpleado:number;
public IncSelProy: string = 'incSelProy';
public IncSelEtapa: string = 'incSelEtapa';
activaproyecto:boolean;
verFiltros = new FormControl('');
search:boolean;
estatus: boolean;
nombre: boolean;
fecha: boolean;
numero: boolean;
prioridad: boolean;
emp: boolean;
listaprioridades: any;
texto = 'Activar Filtros';  
estadoPositivo = true;
listaFiltros: [];
listatiposfiltros: TiposFiltrosIncidencia[];
prioridades = new FormControl();
fec_ini: string;
fec_fin: string;
titulo: string = '';
verestatus = new FormControl();
numeroInci: number;
idUsuario: number;
milistaestatus = [];
listaEstatus: string[] = [
  'ABIERTO',
  'OBSERVACIONES',
  'PROCESO',
  'RESUELTO',
];

configAbierto: any;
configObservacion: any;
configProceso: any;
configResuelto: any;
listaIncAbierto: any[] = [];
totalAbierto: number; 
listaIncObservacion: any[] = [];
totalObservacion: number; 
listaIncProceso: any[] = [];
totalProceso: number;
listaIncResuelto: any[] = [];
totalResuelto: number;

get totalPagesAbierto(): number {
  return this.getTotalPages(this.Abierto);
}

get totalPagesObservacion(): number {
  return this.getTotalPages(this.Observacion);
}

get totalPagesProceso(): number {
  return this.getTotalPages(this.Proceso);
}

get totalPagesResuelto(): number {
  return this.getTotalPages(this.Resultado);
}

private getTotalPages(list: unknown[]): number {
  return Array.isArray(list) && list.length > 0
    ? Math.ceil(list.length / 3)
    : 0;
}


// tiles: Tile[] = [{icon:'lock_open',text: 'Abierto', cols: 1, rows: 1, color: '#26a69a'},{icon:'visibility',text: 'Observacion', cols: 1, rows: 1, color: '#ff9800'},{icon:'find_in_page',text: 'Proceso', cols: 1, rows: 1, color: '#2196f3'},{icon:'done_all',text: 'Resultado', cols: 1, rows: 1, color: '#916EFF'}];


    constructor(
    private router: Router, public dialog:MatDialog, private incidenciasService: IncidenciasService, private fb: FormBuilder
    
  ){
   
  }

  
  ngOnInit() {
     this.proyectocliente =[{Id:1,Name:"Proyecto 1"},{Id:2,Name:"Proyecto 2"},{Id:3,Name:"Proyecto 3"},{Id:4,Name:"Proyecto 4"},{Id:5,Name:"Proyecto 5"},{Id:6,Name:"Proyecto 6"},{Id:7,Name:"Proyecto 7"},{Id:8,Name:"Proyecto 8"},{Id:9,Name:"Proyecto 9"}];
     this.etapacliente =[{idEtapa:1,NombreEtapa:"Etapa 1"},{idEtapa:2,NombreEtapa:"Etapa 2"},{idEtapa:3,NombreEtapa:"Etapa 3"},{idEtapa:4,NombreEtapa:"Etapa 4"},{idEtapa:5,NombreEtapa:"Etapa 5"},{idEtapa:6,NombreEtapa:"Etapa 6"},{idEtapa:7,NombreEtapa:"Etapa 7"},{idEtapa:8,NombreEtapa:"Etapa 8"},{idEtapa:9,NombreEtapa:"Etapa 9"}];
   //  this.estatuscliente=[{idEstatus:1,nombreEstatus:"Abierto"},{idEstatus:2,nombreEstatus:"Obeservaciones"},{idEstatus:3,nombreEstatus:"Proceso"},{idEstatus:4,nombreEstatus:"Resultado"}];
     this.empleadocliente=[{idUsuario:1,nombreE:"Jaime Emmanuel Castorela Guzmán"},{idUsuario:2,nombreE:"Mizrain Galvan Popoca"}];
     //Columna de Abierto
     this.Abierto=[
      {id:101,titulo:'Abierto',colorTitulo:'#26a69a',nombre:"Ejemplo 101",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'4/3/2022',fechaF:"30/6/2022",version:'version 1',archivos:5,comentario:23,color:'black',BTP:"Alta"},
      {id:102,titulo:'Abierto',colorTitulo:'#26a69a',nombre:"Ejemplo 102",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'5/9/2021',fechaF:'28/12/2022',version:'version 2',archivos:15,comentario:23,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:103,titulo:'Abierto',colorTitulo:'#26a69a',nombre:"Ejemplo 103",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'3/24/2012',fechaF:'26/11/2022',version:'version 3',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"},
      {id:104,titulo:'Abierto',colorTitulo:'#26a69a',nombre:"Ejemplo 104",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'6/20/2020',fechaF:'24/2/2022',version:'version 4',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:105,titulo:'Abierto',colorTitulo:'#26a69a',nombre:"Ejemplo 105",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'11/28/2021',fechaF:"22/3/2022",version:'version 5',archivos:10,comentario:2,color:'black',BTP:"Alta"},
      {id:106,titulo:'Abierto',colorTitulo:'#26a69a',nombre:"Ejemplo 106",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'10/12/2021',fechaF:"20/10/2022",version:'version 6',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:107,titulo:'Abierto',colorTitulo:'#26a69a',nombre:"Ejemplo 107",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'9/4/2020',fechaF:"18/9/2022",version:'version 7',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"},
      {id:108,titulo:'Abierto',colorTitulo:'#26a69a',nombre:"Ejemplo 108",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'8/6/2002',fechaF:"16/4/2002",version:'version 8',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:109,titulo:'Abierto',colorTitulo:'#26a69a',nombre:"Ejemplo 109",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'7/2/2022',fechaF:"14/5/2020",version:'version 9',archivos:10,comentario:2,color:'black',BTP:"Alta"},
      {id:110,titulo:'Abierto',colorTitulo:'#26a69a',nombre:"Ejemplo 110",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'12/24/2022',fechaF:"12/6/2021",version:'version 10',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:111,titulo:'Abierto',colorTitulo:'#26a69a',nombre:"Ejemplo 111",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'1/15/2022',fechaF:"10/8/2021",version:'version 11',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"},
      {id:112,titulo:'Abierto',colorTitulo:'#26a69a',nombre:"Ejemplo 112",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'2/8/2022',fechaF:"8/7/2020",version:'version 12',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:113,titulo:'Abierto',colorTitulo:'#26a69a',nombre:"Ejemplo 113",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'4/4/2022',fechaF:"6/3/2012",version:'version 13',archivos:10,comentario:2,color:'black',BTP:"Alta"},
      {id:114,titulo:'Abierto',colorTitulo:'#26a69a',nombre:"Ejemplo 114",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'5/7/2022',fechaF:"4/6/2021",version:'version 14',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:115,titulo:'Abierto',colorTitulo:'#26a69a',nombre:"Ejemplo 115",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'6/6/2022',fechaF:"2/9/2022",version:'version 15',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"}];

      //Columna de Observación
     this.Observacion=[
      {id:201,titulo:'Observaciones',colorTitulo:'#ff9800',nombre:"Ejemplo 201",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'1/4/2022',fechaF:"1/9/2022",version:'version 15',archivos:5,comentario:23,color:'black',BTP:"Alta"},
      {id:202,titulo:'Observaciones',colorTitulo:'#ff9800',nombre:"Ejemplo 202",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'2/5/2021',fechaF:"2/9/2022",version:'version 14',archivos:15,comentario:23,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:203,titulo:'Observaciones',colorTitulo:'#ff9800',nombre:"Ejemplo 203",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'3/6/2012',fechaF:"3/9/2022",version:'version 13',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"},
      {id:204,titulo:'Observaciones',colorTitulo:'#ff9800',nombre:"Ejemplo 204",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'4/1/2020',fechaF:"4/9/2022",version:'version 12',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:205,titulo:'Observaciones',colorTitulo:'#ff9800',nombre:"Ejemplo 205",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'5/2/2021',fechaF:"5/9/2022",version:'version 11',archivos:10,comentario:2,color:'black',BTP:"Alta"},
      {id:206,titulo:'Observaciones',colorTitulo:'#ff9800',nombre:"Ejemplo 206",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'6/3/2021',fechaF:"6/9/2022",version:'version 10',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:207,titulo:'Observaciones',colorTitulo:'#ff9800',nombre:"Ejemplo 207",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'7/4/2020',fechaF:"7/9/2022",version:'version 9',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"},
      {id:208,titulo:'Observaciones',colorTitulo:'#ff9800',nombre:"Ejemplo 208",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'8/5/2002',fechaF:"8/9/2022",version:'version 8',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:209,titulo:'Observaciones',colorTitulo:'#ff9800',nombre:"Ejemplo 209",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'9/6/2022',fechaF:"9/9/2022",version:'version 7',archivos:10,comentario:2,color:'black',BTP:"Alta"},
      {id:210,titulo:'Observaciones',colorTitulo:'#ff9800',nombre:"Ejemplo 210",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'10/7/2022',fechaF:"10/9/2022",version:'version 6',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:211,titulo:'Observaciones',colorTitulo:'#ff9800',nombre:"Ejemplo 211",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'12/8/2022',fechaF:"11/9/2022",version:'version 5',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"},
      {id:212,titulo:'Observaciones',colorTitulo:'#ff9800',nombre:"Ejemplo 212",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'12/9/2022',fechaF:"12/9/2022",version:'version 4',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:213,titulo:'Observaciones',colorTitulo:'#ff9800',nombre:"Ejemplo 213",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'4/10/2022',fechaF:"13/9/2022",version:'version 3',archivos:10,comentario:2,color:'black',BTP:"Alta"},
      {id:214,titulo:'Observaciones',colorTitulo:'#ff9800',nombre:"Ejemplo 214",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'5/11/2022',fechaF:"14/9/2022",version:'version 2',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:215,titulo:'Observaciones',colorTitulo:'#ff9800',nombre:"Ejemplo 215",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'6/12/2022',fechaF:"15/9/2022",version:'version 1',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"}];

      //Columna de Proceso
     this.Proceso=[
      {id:301,titulo:'Proceso',colorTitulo:'#2196f3',nombre:"Ejemplo 301",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'13/9/2022',fechaF:"16/9/2022",version:'version 15',archivos:5,comentario:23,color:'black',BTP:"Alta"},
      {id:302,titulo:'Proceso',colorTitulo:'#2196f3',nombre:"Ejemplo 302",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'14/10/2021',fechaF:"17/9/2022",version:'version 12',archivos:15,comentario:23,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:303,titulo:'Proceso',colorTitulo:'#2196f3',nombre:"Ejemplo 303",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'15/11/2012',fechaF:"18/9/2022",version:'version 9',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"},
      {id:304,titulo:'Proceso',colorTitulo:'#2196f3',nombre:"Ejemplo 304",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'16/12/2020',fechaF:"19/9/2022",version:'version 6',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:305,titulo:'Proceso',colorTitulo:'#2196f3',nombre:"Ejemplo 305",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'17/11/2021',fechaF:"20/9/2022",version:'version 3',archivos:10,comentario:2,color:'black',BTP:"Alta"},
      {id:306,titulo:'Proceso',colorTitulo:'#2196f3',nombre:"Ejemplo 306",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'18/10/2021',fechaF:"21/9/2022",version:'version 1',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:307,titulo:'Proceso',colorTitulo:'#2196f3',nombre:"Ejemplo 307",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'19/9/2020',fechaF:"22/9/2022",version:'version 2',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"},
      {id:308,titulo:'Proceso',colorTitulo:'#2196f3',nombre:"Ejemplo 308",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'20/8/2002',fechaF:"23/9/2022",version:'version 4',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:309,titulo:'Proceso',colorTitulo:'#2196f3',nombre:"Ejemplo 309",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'22/7/2022',fechaF:"24/9/2022",version:'version 5',archivos:10,comentario:2,color:'black',BTP:"Alta"},
      {id:310,titulo:'Proceso',colorTitulo:'#2196f3',nombre:"Ejemplo 310",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'23/6/2022',fechaF:"25/9/2022",version:'version 7',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:311,titulo:'Proceso',colorTitulo:'#2196f3',nombre:"Ejemplo 311",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'14/5/2022',fechaF:"26/9/2022",version:'version 8',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"},
      {id:312,titulo:'Proceso',colorTitulo:'#2196f3',nombre:"Ejemplo 312",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'25/4/2022',fechaF:"27/9/2022",version:'version 10',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:313,titulo:'Proceso',colorTitulo:'#2196f3',nombre:"Ejemplo 313",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'26/3,/2022',fechaF:"28/9/2022",version:'version 11',archivos:10,comentario:2,color:'black',BTP:"Alta"},
      {id:314,titulo:'Proceso',colorTitulo:'#2196f3',nombre:"Ejemplo 314",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'27/2/2022',fechaF:"29/9/2022",version:'version 13',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:315,titulo:'Proceso',colorTitulo:'#2196f3',nombre:"Ejemplo 315",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'28/1/2022',fechaF:"30/9/2022",version:'version 14',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"}];
      
     //Columna de Resultado
     this.Resultado=[
      {id:401,titulo:'Resultado',colorTitulo:'#916EFF',nombre:"Ejemplo 401",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'2/9/2022',fechaF:"3/9/2022",version:'version 15',archivos:5,comentario:23,color:'black',BTP:"Alta"},
      {id:402,titulo:'Resultado',colorTitulo:'#916EFF',nombre:"Ejemplo 402",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'4/6/2021',fechaF:"6/9/2022",version:'version 1',archivos:15,comentario:23,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:403,titulo:'Resultado',colorTitulo:'#916EFF',nombre:"Ejemplo 403",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'6/3/2012',fechaF:"9/9/2022",version:'version 2',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"},
      {id:404,titulo:'Resultado',colorTitulo:'#916EFF',nombre:"Ejemplo 404",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'8/7/2020',fechaF:"12/9/2022",version:'version 14',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:405,titulo:'Resultado',colorTitulo:'#916EFF',nombre:"Ejemplo 405",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'10/8/2021',fechaF:"15/9/2022",version:'version 13',archivos:10,comentario:2,color:'black',BTP:"Alta"},
      {id:406,titulo:'Resultado',colorTitulo:'#916EFF',nombre:"Ejemplo 406",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'12/6/2021',fechaF:"18/9/2022",version:'version 3',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:407,titulo:'Resultado',colorTitulo:'#916EFF',nombre:"Ejemplo 407",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'14/5/2020',fechaF:"21/9/2022",version:'version 4',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"},
      {id:408,titulo:'Resultado',colorTitulo:'#916EFF',nombre:"Ejemplo 408",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'16/4/2002',fechaF:"24/9/2022",version:'version 12',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:409,titulo:'Resultado',colorTitulo:'#916EFF',nombre:"Ejemplo 409",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'18/9/2022',fechaF:"27/9/2022",version:'version 11',archivos:10,comentario:2,color:'black',BTP:"Alta"},
      {id:410,titulo:'Resultado',colorTitulo:'#916EFF',nombre:"Ejemplo 410",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'20/10/2022',fechaF:"30/9/2022",version:'version 5',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:411,titulo:'Resultado',colorTitulo:'#916EFF',nombre:"Ejemplo 411",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'22/3/2022',fechaF:"4/9/2022",version:'version 6',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"},
      {id:412,titulo:'Resultado',colorTitulo:'#916EFF',nombre:"Ejemplo 412",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'24/2/2022',fechaF:"8/9/2022",version:'version 10',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:413,titulo:'Resultado',colorTitulo:'#916EFF',nombre:"Ejemplo 413",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'26/11/2022',fechaF:"16/9/2022",version:'version 7',archivos:10,comentario:2,color:'black',BTP:"Alta"},
      {id:414,titulo:'Resultado',colorTitulo:'#916EFF',nombre:"Ejemplo 414",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'28/12/2022',fechaF:"20/9/2022",version:'version 9',archivos:10,comentario:2,color:'rgb(224, 0, 0)',BTP:"Media"},
      {id:415,titulo:'Resultado',colorTitulo:'#916EFF',nombre:"Ejemplo 415",descripcion:"Este es el primer ejemplo para ver si funciona esta tabla",fechaI:'30/1/2022',fechaF:"24/9/2022",version:'version 8',archivos:10,comentario:2,color:'rgb(241, 180, 48)',BTP:"baja"}];

       }
   
   
   
   
     ngOnDestroy() {
      localStorage.removeItem(this.IncSelProy);
      localStorage.removeItem(this.IncSelEtapa);
    }
/*Captura de proyectos */
    capturarProyecto(id){
      localStorage.setItem(this.IncSelProy, JSON.stringify(id));
      this.consultaetapas(id);
}

/*Captura de etapas */
consultaetapas(id: number) {}
capturaretapa(etapas: number){
  localStorage.setItem(this.IncSelEtapa, JSON.stringify(etapas));
  this.selectEtapa = etapas;
  this.activaproyecto = true;
}

/***  Inicio de Filtros***/
activafiltros() {
  if ((this.texto = this.estadoPositivo ? 'Desactivar Filtros' : 'Activar Filtros')) {
    this.search = true;
    this.incidenciasService.obtenerElementoPorCampoApi('controller/consultatiposFiltrosEnum.do', Constantes.VACIO).subscribe(res => {
    this.listatiposfiltros = res;
  });
  }
  if ((this.estadoPositivo = !this.estadoPositivo)) {
    this.verFiltros = new FormControl();
    this.listaFiltros = [];
    this.search = false;
    this.prioridad = false;
    this.nombre = false;
    this.estatus = false;
    this.fecha = false;
    this.numero = false;
    this.emp = false;
  }
}

reiniciaBanderas(){
  this.estatus = false;
  this.nombre = false;
  this.fecha = false;
  this.numero = false;
  this.prioridad = false;
  this.emp = false;
}

capturafiltro(nombreFiltro) {
  let empAnterior = this.emp;
  this.reiniciaBanderas();
  this.listaFiltros = nombreFiltro; 
  this.listaFiltros.forEach(ab=>{
    switch(ab){
      case 'ESTATUS':
        this.estatus = true;
        break;
      case 'NOMBRE':
        this.nombre = true;
      break;
      case 'RANGO_FECHA':
        this.fecha = true;
      break;
      case 'NUMERO_INCIDENCIA':
        this.numero = true;
      break;
      case 'PRIORIDAD':
        this.incidenciasService.consultaPrioridad().subscribe(res => {
          this.listaprioridades = res;
        });
        this.prioridad = true;
      break;
      case 'EMPLEADO_ASIGNADO':
        this.emp = true;
      break;
    }
    console.log('Filtro ${res}');
  });
  
}

public cambiaEstatus(value) {
  if (null === value || '' === value) {
    return '';
  }
  return FiltrosIncidenciaEnum[value];
}

limpiaFiltros(){
          
  if(this.fecha == false){
    this.fec_ini = '';
    this.fec_fin = '';
    this.fec_ini = null;
    this.fec_fin = null;
  }
  
  if(this.prioridad === false){
    this.prioridades = new FormControl();
  }  
  if(this.nombre === false){
    this.titulo = '';
  }
  if(this.estatus === false){
    this.verestatus = new FormControl();
  }
  if(this.numero === false){
    this.numeroInci = null;
  }
  if(this.emp === false){
    this.idUsuario = null;
  }      
  this.applyFiltersIncidencias();
}

applyFiltersIncidencias(){
 
  }

/* Alta de incidencias*/
// openDialog() {
//   const dialogRef = this.dialog.open(DesarrolloAltas);
//   dialogRef.afterClosed().subscribe(result => {
//     console.log(`Dialog result: ${result}`);
//   });
// }

openDialog(){
  this.dialog.open(DesarrolloAltas, {
    height: '720px',
    width: '1200px',
    panelClass: 'custom-modalbox',
  });
}

// detallesIncidencia(abierto){
//   const dialogRef = this.dialog.open(DetalleErroresComponent);
//   dialogRef.afterClosed().subscribe(res =>{
//     console.log(`Dialog result: ${res}`);
//     datata:abierto
//   })
// }
detallesIncidencia(usuario){
this.dialog.open(DetalleErroresComponent, {
  height: '720px',
  width: '1280px',
  panelClass: 'custom-modalbox2',
  data: usuario
});
}

}
   
